<template>
  <div>
    <div class="artwork artwork--modal">
      <ArtworkImage
        :imageSource="artwork.imageFullUrl"
        :artworkName="artwork.name"
        class="artwork__thumb align-items-start"
        />
      <ArtworkContent :artwork="artwork"/>
    </div>
    <div v-if="artwork.extraDescription" class="d-block artwork__extra-desc">
      <p class="text-muted" v-html="artwork.extraDescription"></p>
    </div>
  </div>
</template>

<script>
  import ArtworkImage from '@/shared/components/artwork_image';
  import ArtworkContent from './artwork_content';

  export default {
    name: 'ModalContent',
    props: {
      artwork: {
        type: Object,
        required: true,
      },
    },
    components: {
      ArtworkImage,
      ArtworkContent,
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/modal/modal_content.vue?61a4d674